var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.266 13.389c.709-.153 1.07.84.585 1.38-1.376 1.533-1.97 3.284-2.228 4.506l-.092.49C4.435 20.36 4.005 21 3.403 21H.913c-.552 0-.99-.448-.901-.993.297-1.819 1.486-5.591 6.254-6.618zM14.913 13.125c7 0 8.556 4.765 8.902 6.882.088.545-.35.993-.902.993h-16c-.552 0-.99-.448-.901-.993.345-2.117 1.9-6.882 8.901-6.882zM9.161 3.007c.708.039.904.889.55 1.503a5.967 5.967 0 00-.798 2.99l.008.309c.05.973.33 1.884.79 2.68.354.614.159 1.465-.549 1.504a4.5 4.5 0 11-.001-8.986zM14.913 3a4.5 4.5 0 11-3.783 2.064l.05-.08.127-.176A4.494 4.494 0 0114.913 3z",
    fill: "currentColor"
  })));
}
SvgSocialFilled.displayName = 'SocialFilled';
export default SvgSocialFilled;